import { CoreRoutingModule } from '@admin/core/core-routing.module';
import { AdminSharedModule } from '@admin/shared/shared.module';
import { HttpClient, HTTP_INTERCEPTORS } from '@angular/common/http';
import { ErrorHandler, NgModule } from '@angular/core';
import { GoogleMapsModule } from '@angular/google-maps';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { RouterModule } from '@angular/router';
import { environment } from '@environment/environment';
import { TranslateLoader, TranslateModule } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { AirbrakeErrorHandler } from '@shared/handlers/airbrake-error.handler';
import { InterceptorService } from '@shared/services/interceptor.service';
import { CustomPreloadingStrategy } from '@shared/strategies/custom.preloading.strategy';
import { PhotoGalleryModule } from '@twogate/ngx-photo-gallery';
import { ChartModule } from 'angular-highcharts';
import { SidebarModule } from 'ng-sidebar';
import { CollapseModule } from 'ngx-bootstrap/collapse';
import { BsDatepickerModule } from 'ngx-bootstrap/datepicker';
import { BsDropdownModule } from 'ngx-bootstrap/dropdown';
import { ModalModule } from 'ngx-bootstrap/modal';
import { PaginationModule } from 'ngx-bootstrap/pagination';
import { TabsModule } from 'ngx-bootstrap/tabs';
import { TooltipModule } from 'ngx-bootstrap/tooltip';
import { TypeaheadModule } from 'ngx-bootstrap/typeahead';
import { CookieService } from 'ngx-cookie-service';
import { LoggerModule, NgxLoggerLevel } from 'ngx-logger';
import { NgxMaskModule } from 'ngx-mask';
import { QuillModule } from 'ngx-quill';
import { ToastrModule } from 'ngx-toastr';
import { UiSwitchModule } from 'ngx-ui-switch';
import { NgxWebstorageModule } from 'ngx-webstorage';

export const createTranslateLoader = (http: HttpClient) =>
  new TranslateHttpLoader(http, './assets/i18n/', '.json');

@NgModule({
  imports: [
    AdminSharedModule,
    BrowserModule,
    BrowserAnimationsModule,
    CoreRoutingModule,
    ChartModule,
    GoogleMapsModule,
    CollapseModule.forRoot(),
    NgxMaskModule.forRoot(),
    PhotoGalleryModule.forRoot({
     
    }),
    BsDropdownModule.forRoot(),
    BsDropdownModule.forRoot(),
    SidebarModule.forRoot(),
    QuillModule.forRoot(),
    ModalModule.forRoot(),
    TabsModule.forRoot(),
    TypeaheadModule.forRoot(),
    PaginationModule.forRoot(),
    TooltipModule.forRoot(),
    BsDatepickerModule.forRoot(),
    NgxWebstorageModule.forRoot({
      prefix: 'admin.onsitehq.co'
    }),
    ToastrModule.forRoot({
      timeOut: 2000,
      toastClass: 'ngx-toastr ohq-toastr',
      preventDuplicates: true
    }),
    LoggerModule.forRoot({
      level: environment.IS_PRODUCTION
        ? NgxLoggerLevel.ERROR
        : NgxLoggerLevel.DEBUG
    }),
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useFactory: createTranslateLoader,
        deps: [HttpClient]
      }
    }),
    UiSwitchModule.forRoot({
      size: 'small',
      color: '#21CE99',
      defaultBgColor: '#FF2721',
      defaultBoColor: 'rgba(0, 0, 0, 0.1)'
    })
  ],
  exports: [RouterModule],
  providers: [
    CustomPreloadingStrategy,
    CookieService,
    {
      provide: ErrorHandler,
      useClass: AirbrakeErrorHandler
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: InterceptorService,
      multi: true
    }
  ]
})
export class CoreModule {}
